// components/ui/pagination.js
import { useEffect } from 'react';
import TablePagination from '@mui/material/TablePagination'; // Adjust import according to the library you're using
import { usePageList } from 'src/contexts/pagination-context';

const Pagination = (props) => {
  const { totalItems, refreshPage } = usePageList();
  const { onPageChange, onRowsPerPageChange, page, rowsPerPage } = props;

  useEffect(() => {
    if (refreshPage || (page >= Math.ceil(totalItems / rowsPerPage))) {
      // Reset to page 0 when data is refreshed
      // Clamp to valid page range
      onPageChange(null, 0);
    }
  }, [refreshPage, totalItems, rowsPerPage]);
  
  // Ensure the page value is within the valid range
  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const validPage = Math.min(Math.max(0, page), Math.max(0, totalPages - 1));
  
  return (
    <TablePagination
      component="div"
      count={totalItems}
      page={validPage} // Use the valid page value
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
      labelRowsPerPage="Rows"
    />
  );
};

export default Pagination;

